<script lang="ts">
    import { blur } from "svelte/transition"
    import { getCachedEntries } from "../../../api"
    import NewsTeaserArticle from "./NewsTeaser_Article.svelte"
    import { location } from "../../store"
    import { applyFilterFromHash, filter2Hash } from "../../utils"

    export let block: ContentBlockEntry

    let loading = true
    let news: ContentEntry[]

    getCachedEntries("content", { type: "news", active: true }, "-news.date", null, null, "newsTeaser").then((data) => {
        loading = true
        news = data
        loading = false
    })

    const categories = [
        { ident: "news", name: "News" },
        { ident: "campaign", name: "Campaign" },
        { ident: "explains", name: "Explains" },
    ]
    let openCatFilter = false
    let newsFilter: { [key: string]: string[] } = {
        category: [],
    }

    let filterInitialized = false

    // first apply filter from initial hash
    $: if (filterInitialized) {
        filter2Hash(newsFilter, true)
    }

    let filteredNews: ContentEntry[]
    function applyFilter(hash: string) {
        const f = applyFilterFromHash(hash, { category: "news.category" }, news, () => {
            if (typeof window !== "undefined") {
                setTimeout(() => {
                    scrollTargetContainer?.scrollIntoView({ behavior: "instant", block: "start", inline: "nearest" })
                    setTimeout(() => {
                        scrollTargetContainer?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
                    }, 600) // after in-view scroll animation
                }, 10)
            }
        })
        filteredNews = f.filteredItems
        if (f.newFilter) {
            newsFilter = f.newFilter
        }
        filterInitialized = true
    }

    $: if (!loading) {
        applyFilter($location.hash)
    }

    let scrollTargetContainer: HTMLDivElement
</script>

<!-- position 100px above -->
<div style="position:relative;">
    <div bind:this="{scrollTargetContainer}" style="position: absolute; top: -100px"></div>
</div>

<div class="container" data-block-cfg="{block.newsArchive}">
    <div class="grid align-start">
        <div class="col-md-3 gray-gradient col-grid gap-s filter-col">
            <div class="col-auto filters-wrapper">
                <button
                    class="h4 filter-headline vp-m"
                    aria-expanded="{openCatFilter}"
                    on:click="{() => (openCatFilter = !openCatFilter)}"
                    >Categories
                    <span class="filter-number">{newsFilter.category.length}</span></button
                >
                <div class="option-group gap-s" class:open="{openCatFilter}">
                    {#each categories as category}
                        <input
                            type="checkbox"
                            id="category_{category.ident}"
                            bind:group="{newsFilter.category}"
                            value="{category.ident}"
                        />
                        <label for="category_{category.ident}">{category.name}</label>
                    {/each}
                </div>
            </div>
        </div>
        <div class="col-md-9">
            <section class="news">
                <div class="grid grid-bleed vp-xl hp-xl gap-m">
                    {#each filteredNews || [] as newsEntry (newsEntry.id)}
                        <fragment transition:blur="{{ amount: 10 }}">
                            <NewsTeaserArticle {newsEntry} />
                        </fragment>
                    {/each}
                </div>
            </section>
        </div>
    </div>
</div>
